package gr.tech.GRAttestation.styles.admin

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px

val AdminTableStickyColumn = CssStyle {
    base {
        Modifier
            .position(Position.Sticky)
            .right(0.px)
            .backgroundColor(Colors.White)
    }
}